export default "/assets/images/leaf-fluttering-in-wind.png?9badd55922b7754f079186cdf536bb96";